import styled from 'styled-components';
import Banner from '../../assets/banner-desktop.jpg';
import Banner2 from '../../assets/banner-desktop-mobile.jpeg';

const BannerStyle = styled.section`
  display: block;
  width: 100%;
  height: 100vh;
  background: #007e78;
  background-image: url(${Banner});
  background-size: cover;
  background-repeat: no-repeat;

  @media(max-width: 800px) {
    height: 550px;
    background-image: url(${Banner2});
    background-position: center 35px;
  }
`;

export default BannerStyle;
